import type { AuthProvider, AuthSession, TenantSummary } from './AuthProvider'
import { read, write, remove, key } from '@/lib/storage'
import { TENANTS, getAuthUsers } from '@/tenant/tenants'

const SESSION_KEY = key<AuthSession>('session', 1)
const SESSION_TTL_MS = 1000 * 60 * 60 * 24 * 30

export class MockAuthProvider implements AuthProvider {
  getSession(): AuthSession | null {
    const s = read(SESSION_KEY)
    if (!s) return null
    if (s.expiresAt < Date.now()) {
      remove(SESSION_KEY)
      return null
    }
    return s
  }

  async login(email: string, password: string): Promise<AuthSession> {
    await new Promise((r) => setTimeout(r, 200))
    const user = getAuthUsers().find((u) => u.email.toLowerCase() === email.toLowerCase())
    if (!user || user.password !== password) {
      throw new Error('invalid-credentials')
    }
    const session: AuthSession = {
      userId: `user:${user.email}`,
      email: user.email,
      tenantId: user.tenantId,
      role: user.role,
      expiresAt: Date.now() + SESSION_TTL_MS,
    }
    write(SESSION_KEY, session)
    return session
  }

  async logout(): Promise<void> {
    remove(SESSION_KEY)
  }

  listTenants(): TenantSummary[] {
    return TENANTS.map((t) => ({ id: t.id, name: t.name }))
  }
}
